import React, { useState, useEffect, useRef } from "react";
import "../../assets/styles/components/model.scss";

import { Link } from "react-router-dom";

import axios from "axios";
import { useHistory } from "react-router";
import { Button, Col, Form, Input, message, Modal, Row } from "antd";

interface Props {
  show: boolean;
  onClick?: () => void;
}
const CreateModel: React.FC<Props> = ({ show, onClick }) => {
  const history = useHistory();
  let [form] = Form.useForm();
  const [typeId, setTypeId] = useState<string>("");

  const [isOpen, setIsOpen] = useState<any>("");

  // const custommerTypes = [
  //   {
  //     name: "Walk in (คนไทย) CNT",
  //     to: "/opd/create/thai",
  //   },
  //   {
  //     name: "Foreign (ต่างชาติ) CNF",
  //     to: "/opd/create/foreign",
  //   },
  //   {
  //     name: "Arab Agency (อาหรับ) CNA",
  //     to: "/opd/create/foreign",
  //   },
  //   {
  //     name: "Chinese Agency (จีน) CNC",
  //     to: "/opd/create/foreign",
  //   },
  //   {
  //     name: "English Agency (ต่างชาติ) CNE",
  //     to: "/opd/create/foreign",
  //   },
  //   {
  //     name: "VIP (CNM)",
  //   },
  //   {
  //     name: "Staff (พนักงาน) CNS",
  //   },
  // ];

  const [custommerTypes, setCustommerTypes] = useState<any>([]);

  const getGender = async () => {
    const types = await axios.get(`/customer-types`).then((res) => {
      return res?.data?.data.sort((a: any, b: any) => (a > b ? 1 : -1));
    });
    let data = [];

    // types.sort((a:any, b:any) => a > b ? 1 : -1)

    for (let i = 0; i < types.length; i++) {
      data.push(
        <Link
          key={i}
          to={types[i].code !== "CNM" ? `/opd/create/${types[i]._id}` : "/opd/"}
          className="none-underline"
          onClick={(e: any) => {
            console.log("e", types[i]._id);
            if (types[i].code === "CNM") {
              // showCheckName();
              // history.push(`/opd/create/${types[i]._id}`);
              setTypeId(types[i]._id);
              setIsOpen(true);
            }
          }}
        >
          <div className="name">{types[i].name}</div>
          <div className={i === 6 ? "" : `line`} />
        </Link>
      );
    }

    setCustommerTypes(data);
  };

  const onSubmit = (val: any) => {
    console.log("val", val);
    axios
      .get(`/user-vip?name=${val?.name}&surName=${val?.surname}`)
      .then((res) => {
        let data = res?.data?.data;
        console.log("res", data);
        if (data.length > 0) {
          history.push(`/opd/create/${typeId}?idVip=${data[0]?._id}`);
        } else {
          message.error("ไม่มีชื่อใน Vip");
        }
      });
    setIsOpen(false);

    form.setFieldsValue({ name: "", surname: "" });
  };
  useEffect(() => {
    getGender();
  }, []);

  return (
    <div className={`${show ? "modal-open" : "modal-close"}`}>
      <Modal
        visible={isOpen}
        // onClose={onClose}
        footer={false}
        onCancel={() => setIsOpen(false)}
        // style={{ marginLeft: "500px" }}
        // width={"500px"}
        centered
      >
        <h6>ตรวจสอบรายชื่อ VIP /Check List VIP</h6>
        <Form form={form} onFinish={onSubmit}>
          <Row
            justify="space-around"
            className="modal-checkname"
            style={{ padding: "10px 10px " }}
          >
            <Col span={11}>
              <p>ชื่อ/NAME</p>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please Input Name!",
                  },
                ]}
              >
                <Input placeholder="Name" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={11}>
              <p>นามสกุล/SURNAME</p>
              <Form.Item
                name="surname"
                rules={[
                  {
                    required: true,
                    message: "Please Input Surname!",
                  },
                ]}
              >
                <Input placeholder="Surname" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center" style={{ padding: "10px 10px " }}>
            <Button
              htmlType="submit"
              // onClick={onClick}
              style={{
                background: "#4D7E7F",
                color: "white",
                height: "50px",
                width: "160px",
                borderRadius: "0.25rem",
                marginTop: "10px",
                marginLeft: "10px",
              }}
            >
              SUBMIT
            </Button>
          </Row>
        </Form>
      </Modal>

      <div className="custom">
        <div className="btn-close" onClick={onClick}>
          {/* <Icon path={mdiClose} size="30" /> */}
        </div>
        <div className="title">
          <b>Customer Type</b>
        </div>
        <div>
          {custommerTypes}
          {/* {custommerTypes.map((type, index) => (
            <Link key={index} to={type.to || "#"} className="none-underline">
              <div className="name">{type.name}</div>
              <div className={index === 6 ? "" : `line`} />
            </Link>
          ))} */}
        </div>
      </div>
    </div>
  );
};
export default CreateModel;
